// extracted by mini-css-extract-plugin
export default {"colorTextLabel":"L2-z","colorTextValue":"M2-z","swatches":"N2-z","collapseLink":"O2-z","isCollapsed":"P2-z","dropdown":"Q2-z","disabled":"R2-z"};